var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verification-status-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "acc-verification-status",
        class: [
          { status_verified: _vm.isVerified },
          { status_not_verified: !_vm.isVerified }
        ]
      },
      [
        _vm.isVerified
          ? _c("div", { staticClass: "ver-status color-blue" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.Verified"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "icon-verified" })
            ])
          : _c("div", { staticClass: "ver-status color-red" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.NonVerified"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "icon-not-verified" })
            ]),
        _vm._v(" "),
        !_vm.isVerified
          ? _c("div", [
              _c(
                "span",
                {
                  staticClass: "edit-here color-red",
                  on: { click: _vm.forwardToVerify }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "Account.SequentialVerification.VerifyByPin.Verification.Verify"
                      )
                    ) + " "
                  ),
                  _c("v-icon", { staticClass: "color-red" }, [
                    _vm._v("chevron_right")
                  ])
                ],
                1
              )
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "acc-verification-info" }, [
      _vm.detail === "phone"
        ? _c("div", [
            _vm.isVerified
              ? _c("span", {
                  staticClass: "acc_infomsg_default",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.SequentialVerification.VerifyByPin.Verification.Phone.Verified"
                      )
                    )
                  }
                })
              : _c("span", {
                  staticClass: "acc_infomsg_default",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.SequentialVerification.VerifyByPin.Verification.Phone.NotVerified"
                      )
                    )
                  }
                })
          ])
        : _vm.detail === "email"
        ? _c("div", [
            _vm.isVerified
              ? _c("span", {
                  staticClass: "acc_infomsg_default",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.SequentialVerification.VerifyByPin.Verification.Email.Verified"
                      )
                    )
                  }
                })
              : _c("span", {
                  staticClass: "acc_infomsg_default",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.SequentialVerification.VerifyByPin.Verification.Email.NotVerified"
                      )
                    )
                  }
                })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c2f0038", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2f0038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/AccountVerificationStatus.vue
// module id = null
// module chunks = 